import axios from "axios";

const baseURL = `/api/v1/faq`;

const headerConfig = () => {
  return {
    headers: {
      "Content-Type": "application/json",
    },
  };
};

const getFAQs = () => {
  const headers = headerConfig();

  return axios.get(baseURL, headers);
};

export const faqAPI = {
    getFAQs,
};
